export default __webpack_public_path__ + "8c7db0d86941e5d62075e7cad98a2674.jpg";